import React from 'react';
import Clipboard from 'clipboard';

class SMCopyText extends React.Component {
  componentWillMount() {
    this.clipboard = new Clipboard('.copy');
    this.clipboard.on('success', function(e) {
      e.clearSelection();

      // Copied Animation
      if (e.text) {
        const elem = e.trigger;
        elem.setAttribute('aria-label', "コピーしました");
        setTimeout(function() {
          elem.setAttribute('aria-label', "");
        }, 1000);
      }

      // Google Analytics
      const gaLabel = e.trigger.getAttribute('data-ga-label');
      if (typeof ga != 'function') {
        return;
      }
      ga('send', 'event', 'button', 'click', gaLabel);
    });
  }

  componentWillUnmount() {
    this.clipboard.destroy();
    this.clipboard = null;
  }

  textSelectAll(e) {
    e.target.select(e.target.value);
  }

  render() {
    const url = this.props.url;
    const gaLabel = this.props.gaLabel;
    return (
      <div>
        <input className="referral__content-url copy-target" type="text" defaultValue={url} onClick={this.textSelectAll.bind(this)} readOnly />
        <span className="hint--medium hint--bottom hint--rounded button-blue referral__content-copy-button copy" aria-label="" data-clipboard-target=".copy-target" data-ga-label={gaLabel}>コピー</span>
      </div>
    );
  };
}
export default SMCopyText;




// WEBPACK FOOTER //
// ./app/javascript/components/social/SMCopyText.jsx